import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useQueryClient } from '@tanstack/react-query';

import Button from 'components/shared/Buttons/Button';

import { updateMultiple } from '../lib/helper';

const ButtonActions = ({ selectedRows = [], setSelectedRows = () => {} }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [loading, setLoading] = useState({
    unread: false,
    read: false
  });

  return (
    <>
      <Button
        text="Mark as unread"
        icon="eye-slash-mono"
        size="small"
        iconColor="white"
        loading={loading?.unread}
        onClick={() =>
          updateMultiple({
            notifications: selectedRows?.map((n) => n?.data?.id),
            data: { dataToBeUpdated: { is_read: false } },
            setSelectedRows,
            navigate,
            queryClient,
            setLoading
          })
        }
      />
      <Button
        text="Mark as read"
        icon="eye-mono"
        size="small"
        iconColor="white"
        loading={loading?.read}
        onClick={() =>
          updateMultiple({
            notifications: selectedRows?.map((n) => n?.data?.id),
            data: { dataToBeUpdated: { is_read: true } },
            setSelectedRows,
            navigate,
            queryClient,
            setLoading
          })
        }
      />
    </>
  );
};
export default ButtonActions;
